export const SET_TASKS = "tasks@SET_TASKS";
export const FIND_IFLOW_TASKS_BY_FILTERS = "tasks@FIND_IFLOW_TASKS_BY_FILTERS";
export const UPDATE_READFLAG = "tasks@UPDATE_READFLAG";
export const SET_UPDATE_READFLAG = "taskFolders@SET_UPDATE_READFLAG";

export const setTasks = (tasks) => {
  return { type: SET_TASKS, data: tasks };
};

export const findIflowTasksByFilters = (payload) => ({
  type: FIND_IFLOW_TASKS_BY_FILTERS,
  payload,
});

export const updateReadFlag = (
  read_flag,
  flowid,
  flowname,
  pnumber,
  subpid
) => {
  return {
    type: UPDATE_READFLAG,
    data: { read_flag, flowid, flowname, pnumber, subpid },
  };
};

export const setupdateReadFlag = (result) => {
  return { type: SET_UPDATE_READFLAG, data: result };
};
